// Components
import PageBuilder from '@src/quince-site-common/src/organisms/pageBuilder'
// Domains
import SectionRenderer from '@src/SectionRenderer'

import { ADDITIONAL_CUSTOM_SECTIONS } from './partnerPDPLandingPage.constant'

// @i18n-ignore
const PARTNER_PRODUCT_PDP_PAGE = 'partnerProductPDPPage'

function PartnerPDPLandingPage({ pageData, isMobile }: { pageData: any; isMobile: boolean }) {
  if (!pageData) {
    throw new Error('Page data is not defined please check build script')
  }
  const sectionRenderer = SectionRenderer({
    tracker: PARTNER_PRODUCT_PDP_PAGE,
    partnerProduct: pageData?.partnerProduct,
    additionalCustomSections: ADDITIONAL_CUSTOM_SECTIONS,
  })

  return (
    <PageBuilder
      context={pageData}
      selfContainerRenderer={sectionRenderer}
      className={'hide-horizontal-scroll'}
      isMobile={isMobile}
    />
  )
}

export default PartnerPDPLandingPage
